import { Box, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import {
    DownloadRequiredDocumentsButton,
    InternalDocumentsTab,
    RequiredDocumentsTab,
} from '@europrocurement/l2d-modules';

import {
    DOC_TYPE_DOWNLOADABLE,
    DOC_TYPE_INTERNAL,
    DOC_TYPE_REQUIRED,
} from '@europrocurement/l2d-domain';
import DocumentTabFooterActions from '../DocumentTabFooterActions/DocumentTabFooterActions';
import DownloadableDocumentsTab from '../DownloadableDocumentsTab/DownloadableDocumentsTab';

const DocumentsTabs: React.FunctionComponent = function () {
    const { breakpoints } = useTheme();
    const isLargeScreen = useMediaQuery(breakpoints.down('lg'));

    return (
        <Box>
            <Box
                sx={{
                    display: 'flex',
                    gap: '8px',
                    justifyContent: 'center',
                    flexWrap: isLargeScreen ? 'wrap' : 'nowrap',
                }}
            >
                <RequiredDocumentsTab>
                    <DocumentTabFooterActions
                        docType={DOC_TYPE_REQUIRED}
                        addDocBtnLabel="Ajouter un document requis"
                        additionalActions={[<DownloadRequiredDocumentsButton />]}
                    />
                </RequiredDocumentsTab>

                <DownloadableDocumentsTab>
                    <DocumentTabFooterActions
                        docType={DOC_TYPE_DOWNLOADABLE}
                        addDocBtnLabel="Ajouter un document remis"
                    />
                </DownloadableDocumentsTab>

                <InternalDocumentsTab>
                    <DocumentTabFooterActions
                        docType={DOC_TYPE_INTERNAL}
                        addDocBtnLabel="Ajouter un document interne"
                    />
                </InternalDocumentsTab>
            </Box>
        </Box>
    );
};

export default DocumentsTabs;
